export default "__VITE_ASSET__kRAQdQsF__"